export default __webpack_public_path__ + "static/media/netvrk-v2-10.0f50d7b9.jpg";